import { calendar } from './modules/calendar';
import { select } from './modules/select';
import { wickedpicker } from './modules/wickedpicker';
import { addForm } from './modules/addForm';

$(function() {
  calendar();
  select();
  wickedpicker();
  addForm();
});
